import React from "react";
import { StyleSheet, Image, View, Text, Platform } from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import { commonMetricsStyle } from "../assets/css/commonMetricsStyle";
import { responsiveTableStyle } from "../assets/css/responsiveTableStyle";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import Touchable from "./TouchableComponent";
import SearchDataTableComponent from "./SearchDataTableComponent";
import { PAM_TYPES } from "../constant/app.data.constant";


import newBillsIcon from "../assets/images/New-bills.png";
import outstandingIcon from "../assets/images/Outstanding.png";
import overdueIcon from "../assets/images/Overdue.png";
import acceptIcon from "../assets/images/accept.png";
import rejectIcon from "../assets/images/reject.png";
import pamNew from "../assets/images/pamNew.png";
import pamActive from "../assets/images/pamActive.png";
import pamDeclined from "../assets/images/pamDeclined.png";
import attachedFileIcon from "../assets/images/attachedFileIcon.png";
import downArrow from "../assets/images/downArrow.png";
import upArrow from "../assets/images/upArrow.png";

export default class DashboardHeaderSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenPriorityInfoTooltip: false,
      activeBillAccordion: true,
      activePamAccordion: true,
    }
  }

  componentDidMount() {
    const { isMobileDevice } = this.props;
    if(isMobileDevice) this.setState({ activePamAccordion: false });
  }

  onClickPriorityInfo = () => {
    this.setState({
      isOpenPriorityInfoTooltip: !this.state.isOpenPriorityInfoTooltip,
    });
    this.timer = setTimeout(() => {
      this.setState({
        isOpenPriorityInfoTooltip: false,
      });
    }, 5000)
  };

  handleBillAccordion = () => this.setState({activeBillAccordion: !this.state.activeBillAccordion});
  handlePamAccordion = () => this.setState({activePamAccordion: !this.state.activePamAccordion});

  renderBlock(count, icon, label, style, isPamBlock = false) {
    const { selectedScreen } = this.props;
    return (
      <Touchable key={label} style={[responsiveTableStyle.countBoxWrapper, count > 0 ? null : customCommonStyles.cursorDefault, selectedScreen !== "RTP" && responsiveTableStyle.sepaCountBoxWrapper]} onPress={() => !!count ? this.props.onBlockNavigatation(label, isPamBlock) : null}>
        <View style={[responsiveTableStyle.countBox, style]}>
          <View style={[responsiveTableStyle.countBoxImage, commonStyles.justifyContentSpaceBetween]}>
            <View style={[responsiveTableStyle.mView]}>
              <Text style={[responsiveTableStyle.billCountText, commonStyles.marLT0, commonStyles.marRT0, commonFontStyles.workSans, styles.customHeading5, commonStyles.fontWeight600, commonStyles.contentColor]}>{count}</Text>
            </View>
            <View style={[responsiveTableStyle.countBoxImg]}>
              <Image source={icon} style={responsiveTableStyle.dollarSign} />
            </View>
          </View>
          <View style={[commonStyles.dFlex, commonStyles.flexDirectionColumn, commonStyles.flex1, commonStyles.justifyContentCenter, responsiveTableStyle.countBoxTextHolder]}>
            <View style={[responsiveTableStyle.countBoxTitle]}>
              <Text style={[responsiveTableStyle.countBoxTitleText, commonStyles.fontWeight600, commonFontStyles.workSans, styles.customHeading4, commonStyles.fontWeight400, commonStyles.contentColor]}>{label}</Text>
            </View>
            <View style={[commonStyles.webView]}>
              <Text style={[responsiveTableStyle.billCountText, commonFontStyles.workSans, commonStyles.contentColor, styles.customHeading5, commonStyles.fontWeight600]}>{count}</Text>
            </View>
          </View>
        </View>
      </Touchable>
    )
  }

  render() {
    const { newBillCount, outstandingBillCount, overdueBillCount, newPAMCount, acceptPAMCount, rejectPAMCount, selectedScreen, acceptBillCount, rejectBillCount, isMobileDevice = false, getPageData, convertToCSV, onViewAllNavigation, searchText  } = this.props;
    const { activeBillAccordion, activePamAccordion } = this.state
    return (
      <View style={[responsiveTableStyle.dashboardHeader, customCommonStyles.customDashboardHeader, commonStyles.pageBorderRadius5, styles.borderRadiusBottom0]}>
        <View style={styles.outerContainer}>
        <Touchable onPress={() => this.handleBillAccordion()} >
          <View style={[styles.accordionStyle, !!activeBillAccordion ? null : styles.customRadiusAndMarginBottom]}>
          <Text style={[ commonFontStyles.workSans, commonStyles.titleTextHeader2]}>
            {selectedScreen === "RTP" ? `Bills (${newBillCount + outstandingBillCount + overdueBillCount })` : "Bills"}
          </Text>
          <View>
            <Image source={!!activeBillAccordion ? upArrow : downArrow} style={[commonStyles.icon12, styles.accordionIconStyle]} />
          </View>
          </View>
        </Touchable>
        <View style={[commonStyles.flex1, commonStyles.justifyContentSpaceBetween, responsiveTableStyle.countBoxHolder, commonStyles.flexDirectionRow, customCommonStyles.customCountBoxHolder, selectedScreen !== "RTP" && commonStyles.flexWrap, styles.padding8, !!activeBillAccordion ? null : commonStyles.displayNone ]}>
        {this.renderBlock(newBillCount, newBillsIcon, "New",  responsiveTableStyle.newBills)}
        {selectedScreen === "RTP" && this.renderBlock(outstandingBillCount, outstandingIcon, "Outstanding",  responsiveTableStyle.outstanding)}
        {selectedScreen !== "RTP" && this.renderBlock(acceptBillCount, acceptIcon, "Accepted",  responsiveTableStyle.accept)}
        {selectedScreen !== "RTP" && this.renderBlock(rejectBillCount, rejectIcon, "Rejected",  responsiveTableStyle.overdue)}
        {selectedScreen === "RTP" && this.renderBlock(overdueBillCount, overdueIcon, "Overdue",  responsiveTableStyle.overdue)}
        </View>
        </View>
        <View style={styles.outerContainer}>
        <Touchable onPress={() => this.handlePamAccordion()} >
          <View style={[styles.accordionStyle, !!activePamAccordion ? null : styles.customRadiusAndMarginBottom]} >
          <Text style={[ commonFontStyles.workSans, commonStyles.titleTextHeader2]}>
            {`PAM (${newPAMCount + acceptPAMCount + rejectPAMCount })`}
          </Text>
          <View>
            <Image source={!!activePamAccordion ? upArrow : downArrow} style={[commonStyles.icon12, styles.accordionIconStyle]} />
          </View>
          </View>
        </Touchable>
        <View style={[commonStyles.flex1, commonStyles.justifyContentSpaceBetween, responsiveTableStyle.countBoxHolder, commonStyles.flexDirectionRow, customCommonStyles.customCountBoxHolder, selectedScreen !== "RTP" && commonStyles.flexWrap, styles.padding8, selectedScreen === "RTP" && !!activePamAccordion ? null : commonStyles.displayNone]}>
          {this.renderBlock(newPAMCount, pamNew, PAM_TYPES.NEW,  responsiveTableStyle.newPAM, true)}
          {this.renderBlock(acceptPAMCount, pamActive, PAM_TYPES.ACTIVE,  responsiveTableStyle.activePAM, true)}
          {this.renderBlock(rejectPAMCount, pamDeclined, PAM_TYPES.DECLINED,  responsiveTableStyle.declinedPAM, true)}
        </View>
        </View>
        <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.justifyContentSpaceBetween, responsiveTableStyle.titleDiv, commonStyles.alignItemsCenter, responsiveTableStyle.dashboardTitleDiv, isMobileDevice ? null : commonStyles.displayNone ]}>
          <View style={[responsiveTableStyle.priorityInfoTooltipHolder, commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.alignItemsCenter]}>
            <View onPress={() => this.props.navigateTo("dashboard")} style={responsiveTableStyle.priorityListTxt}>
                <Text style={[commonMetricsStyle.heading6, commonStyles.darkGrayColor, commonStyles.fontWeight600, commonFontStyles.workSans, commonMetricsStyle.heading6, commonStyles.contentColor]}>
                  Priority List
                </Text>
            </View>
            {/* <IconButton icon="help" size="small" key="help" style={[styles.customMargin]} onPress={this.onClickPriorityInfo} /> */}
            {/* {this.state.isOpenPriorityInfoTooltip && (
              <View style={[responsiveTableStyle.priorityInfoTooltip, commonStyles.flex1, commonStyles.flexDirectionRow, customCommonStyles.customPriorityInfoTooltip, commonStyles.justifyContentSpaceBetween]}>
                <View>
                  <Text style={[commonMetricsStyle.helperTextFontStyle, commonFontStyles.workSans, commonStyles.darkGrayColor]}>List of "Prioritized"</Text>
                </View>
                <Image source={bookmaredActiveIcon} style={responsiveTableStyle.bookedMark} />
                <View>
                  <Text style={[commonMetricsStyle.helperTextFontStyle, commonFontStyles.workSans, commonStyles.darkGrayColor]}>bills</Text>
                </View>
                <View style={[responsiveTableStyle.priorityInfoTooltipArrow, customCommonStyles.customArrowPosition]}></View>
              </View>
            )} */}
          </View>
          {isMobileDevice ? <>
            <SearchDataTableComponent getPageData={getPageData} searchText={searchText} style={[ Platform.OS !== "web" ? styles.right0 : null]}/>
            <View tooltip={'Export to CSV'} style={[commonStyles.paddingRight16]} >
              <Touchable onPress={() => convertToCSV()}>
                <Image source={attachedFileIcon} style={commonStyles.icon18} />
              </Touchable>
            </View>
            <Touchable onPress={() => onViewAllNavigation()}>
              <View tooltip={'View All Bills'}>
                <Text style={[commonMetricsStyle.heading6, commonStyles.fontWeight500, commonStyles.exSmallHeading, commonFontStyles.workSans, responsiveTableStyle.viewAllLink]}>View All</Text>
              </View>
            </Touchable>
            </> 
          : null}
         </View>
      </View>
    )

  }
}

const styles = StyleSheet.create({
  customMargin: {
    marginTop: 0,
    marginLeft: 6,
    marginBottom: 0,
    marginRight: 6,
    height: 29
  },
  customHeading5: {
    fontSize: 16,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          fontSize: 13,
        };
    },
  },
  customHeading4: {
    fontSize: 14,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          fontSize: 13,
        };
    },
  },
  borderRadiusBottom0: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  outerContainer: {
    backgroundColor: "#fff",
    borderRadius: 5,
  },
  accordionStyle: {
    "flex": 1,
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "#fff",
    "height": 26,
    "marginBottom": 0,
    "padding": 6,
    paddingLeft: 16,
    paddingRight: 16,
    borderWidth: 1,
    borderRadius: 5,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: "#e2e2e2",
    borderStyle: "solid",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          backgroundColor: '#f4f4f4',
        };
    },
  },
  padding8: {
    padding: 16,
    paddingTop: 12,
    paddingBottom: 12,
    borderColor: "#e2e2e2",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0,
    borderRadius: 5,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    marginBottom: 12,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginBottom: 0,
        };
    },
  },
  accordionIconStyle: {
    position: 'relative',
    top: 2,
  },
  customRadiusAndMarginBottom: {
    marginBottom: 12,
    borderRadius: 5,
  },
  right0: {
    right: 0
  }
});
